<template>
  <sidebar-row align-class="align-start">
    <template #actionIcon>
      <v-row no-gutters class="justify-center">
        <v-col cols="auto">
          <div class="outSideIcon">
            <v-icon color="white" small>
              mdi-account
            </v-icon>
          </div>
        </v-col>
      </v-row>
    </template>
    <v-row no-gutters>
      <v-col class="noteContainer">
        <v-row class="notePanel" no-gutters>
          <v-col class="noteOwner" cols="auto">{{ note.ownerName }}</v-col>
          <v-col class="noteDate" cols="auto">{{ note.dateAdded }}</v-col>
          <v-col v-if="note.module === 'ils_easy'" class="noteIls" cols="auto">{{
            `(${ilsEasyModuleVerboseName})`
          }}</v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <dots-menu :items="note.dotsItems" @delete="$emit('delete', note.id)" font-size="18px"></dots-menu>
          </v-col>
        </v-row>
        <v-row class="noteText" no-gutters style="width: inherit">
          <v-col cols="auto">
            {{ note.content }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </sidebar-row>
</template>

<script>
import { get } from 'vuex-pathify';
import DotsMenu from '@/components/DotsMenu';
import SidebarRow from '@/components/SidebarRow';

export default {
  name: 'TheNote',
  props: {
    note: {
      type: Object,
      required: true,
    },
  },
  components: { SidebarRow, DotsMenu },
  computed: {
    ilsEasyModuleVerboseName: get('admin/additionalModules@ILS_EASY_MODULE.verbose_name'),
  },
};
</script>

<style scoped>
.outSideIcon {
  background: #1a73e8;
  box-shadow: 0 1px 5px 0 #0000001f, 0 2px 2px 0 #00000024, 0 1px 1px 0 #00000033;
  border: 4px solid white;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  border-radius: 50%;
  height: 34px;
  width: 34px;
  position: relative;
}
.noteContainer {
  border: 1px solid rgba(0, 0, 0, 0.12);
}
.noteText {
  padding: 10px 26px 10px 8px;
  text-align: left;
  font-size: 12px;
  white-space: pre-line;
}
.noteDate {
  font-size: 10px;
  color: rgba(0, 0, 0, 0.59);
  text-align: left;
  margin-left: 10px;
  margin-bottom: 5px;
}
.noteIls {
  font-size: 10px;
  color: rgba(0, 0, 0, 0.59);
  text-align: left;
  margin-left: 5px;
  margin-bottom: 5px;
}
.noteOwner {
  text-align: left;
  padding: 0;
  font-size: 13px;
  margin-left: 8px;
  margin-bottom: 5px;
}
.notePanel {
  align-items: center;
}
</style>
